import { ChromeReaderMode, HelpOutline, SchoolOutline, VideoCamera, ViewAgenda } from '@openedx/paragon/icons';
export let BlockTypes = /*#__PURE__*/function (BlockTypes) {
  BlockTypes["course"] = "course";
  BlockTypes["sequential"] = "sequential";
  BlockTypes["vertical"] = "vertical";
  BlockTypes["problem"] = "problem";
  BlockTypes["video"] = "video";
  return BlockTypes;
}({});
export const ICON_MAP = {
  [BlockTypes.course]: SchoolOutline,
  [BlockTypes.sequential]: ViewAgenda,
  [BlockTypes.vertical]: ChromeReaderMode,
  [BlockTypes.problem]: HelpOutline,
  [BlockTypes.video]: VideoCamera
};